import React from 'react';
import { Card, CardActionArea, CardContent, Grid, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Gift, Users } from 'react-feather';
import { OrderPageData } from '../../api';
import { useOrderPage } from '../orderPageContext/useOrderPage';
import { OrderPageIntent } from '../OrderPageIntent';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { quotePrice } from '../core/pricing';
import { useIntentConfig } from '../intentConfig/useIntentConfig';

const GiftCardTypeStep = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { orderPageState, setOrderPageState } = useOrderPage();
  const { currentStepIndex } = useIntentConfig();
  const nextStepIndex = currentStepIndex + 1;

  const chooseExperienceVoucher = () => {
    setOrderPageState({
      ...orderPageState,
      activeStep: nextStepIndex,
      orderPageIntent: OrderPageIntent.GIFT_CARD,
      details: {
        ...orderPageState.details,
        price: quotePrice({
          orderPage: orderPageState.orderPage as OrderPageData,
          details: orderPageState.details,
          dateDetails: orderPageState.dateAndTimeDetails,
          account: orderPageState.account,
        }).total,
      },
    });
  };

  const chooseMonetaryVoucher = () => {
    setOrderPageState({
      ...orderPageState,
      activeStep: nextStepIndex,
      orderPageIntent: OrderPageIntent.MONETARY_GIFT_CARD,
      details: { ...orderPageState.details, price: 0 },
    });
  };

  const options = [
    {
      key: 'experience',
      icon: <Users size={28} color={theme.customTheme.palette.text.button.outlined} />,
      title: t('giftCardTypeStep.experience', { persons: orderPageState.details.persons }),
      description: t('giftCardTypeStep.experienceDescription'),
      onClick: chooseExperienceVoucher,
    },
    {
      key: 'monetary',
      icon: <Gift size={28} color={theme.customTheme.palette.text.button.outlined} />,
      title: t('giftCardTypeStep.monetary'),
      description: t('giftCardTypeStep.monetaryDescription'),
      onClick: chooseMonetaryVoucher,
    },
  ];

  return (
    <Grid container flexDirection="column" gap={2}>
      <OrderPageTypography variant="h3" bold>
        {t('giftCardTypeStep.title')}
      </OrderPageTypography>
      {options.map((option) => (
        <Card
          key={option.key}
          variant="outlined"
          sx={{
            backgroundColor: theme.customTheme.palette.background,
            borderColor: theme.customTheme.palette.border,
            borderRadius: '12px',
          }}>
          <CardActionArea onClick={option.onClick}>
            <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {option.icon}
              <Grid display="flex" flexDirection="column" gap={0.5}>
                <OrderPageTypography variant="h6" bold>
                  {option.title}
                </OrderPageTypography>
                <OrderPageTypography variant="body2">{option.description}</OrderPageTypography>
              </Grid>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Grid>
  );
};

export default GiftCardTypeStep;
